import { Models } from '@rematch/core';

import auth from './auth/auth';
import content from './content/content';
import toast from './toast/toast';
import odds from './odds/odds';
import events from './events/events';
import account from './account/account';
import betslip from './betslip/betslip';
import lotto from './lotto/lotto';
import filters from './filters/filters';
import racing from './racing/racing';
import peripherals from './peripherals/peripherals';

export interface RootModel extends Models<RootModel> {
	auth: typeof auth,
  content: typeof content,
  toast: typeof toast,
  odds: typeof odds,
  events: typeof events,
  account: typeof account,
  betslip: typeof betslip,
  lotto: typeof lotto,
  filters: typeof filters,
  racing: typeof racing,
  peripherals: typeof peripherals
}

export const models: RootModel = {
  auth,
  content,
  toast,
  odds,
  events,
  account,
  betslip,
  lotto,
  filters,
  racing,
  peripherals
};
